import { RadioGroup } from './radio-group.component';
import { GroupChangeEventDetail } from './types';

export * from './radio-group.component';
export default RadioGroup;

RadioGroup.define('der-ui-radio-group');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-radio-group': CustomEvent<GroupChangeEventDetail>;
    }
}
